// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_linkEditor__iQo0- {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;

    display: flex;

    width: 100%;
    max-width: 400px;

    transition: opacity 0.5s;

    opacity: 0;
    border-radius: 0 0 8px 8px;
    background-color: #fff;
    box-shadow: 0 5px 10px rgb(0 0 0 / 30%);
    will-change: transform;
  }

  .styles_linkInput__cL4Ul {
    position: relative;

    display: block;

    box-sizing: border-box;
    width: calc(100% - 75px);
    margin: 12px;
    padding: 8px 12px;

    color: rgb(5 5 5);
    border: 0;
    border-radius: 15px;
    outline: 0;
    background-color: #eee;

    font-family: inherit;
    font-size: 15px;
  }

  .styles_linkView__8Vze8 {
    position: relative;

    display: block;

    width: calc(100% - 24px);
    margin: 8px 12px;
    padding: 8px 12px;

    color: rgb(5 5 5);
    border: 0;
    border-radius: 15px;
    outline: 0;

    font-family: inherit;
    font-size: 15px;
  }
  
  
  .styles_link-editor__MBiA2 .styles_button__pt-ye {
    display: inline-block;

    width: 20px;
    height: 20px;
    margin: 0 2px;
    padding: 6px;

    cursor: pointer;

    border-radius: 8px;
  }
  
  .styles_link-editor__MBiA2 .styles_button__pt-ye.styles_hovered__HmGK- {
    display: inline-block;

    width: 20px;
    height: 20px;

    background-color: #eee;
  }
  
  .styles_link-editor__MBiA2 .styles_button__pt-ye i,
  .styles_actions__ywMuf i {
    display: inline-block;

    width: 20px;
    height: 20px;

    vertical-align: -0.25em;

    background-size: contain;
  }

  .styles_linkCancel__0Jjuh {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;

    margin-right: 28px;

    cursor: pointer;
    vertical-align: -0.25em;
  }

  .styles_linkConfirm__j7xi0 {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;

    margin-right: 2px;

    cursor: pointer;
    vertical-align: -0.25em;
  }

  .styles_linkTrash__R-OrF {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;

    cursor: pointer;
    vertical-align: -0.25em;
  }

  .styles_linkEdit__QOrjk {
    position: absolute;
    top: 0;
    right: 30px;
    bottom: 0;

    cursor: pointer;
    vertical-align: -0.25em;
  }`, "",{"version":3,"sources":["webpack://./src/components/form/Editor/plugins/FloatingLinkEditorPlugin/styles.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;;IAEP,aAAa;;IAEb,WAAW;IACX,gBAAgB;;IAEhB,wBAAwB;;IAExB,UAAU;IACV,0BAA0B;IAC1B,sBAAsB;IACtB,uCAAuC;IACvC,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;;IAElB,cAAc;;IAEd,sBAAsB;IACtB,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;;IAEjB,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,sBAAsB;;IAEtB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,kBAAkB;;IAElB,cAAc;;IAEd,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;;IAEjB,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,UAAU;;IAEV,oBAAoB;IACpB,eAAe;EACjB;;;EAGA;IACE,qBAAqB;;IAErB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;;IAEZ,eAAe;;IAEf,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;;IAErB,WAAW;IACX,YAAY;;IAEZ,sBAAsB;EACxB;;EAEA;;IAEE,qBAAqB;;IAErB,WAAW;IACX,YAAY;;IAEZ,uBAAuB;;IAEvB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;;IAET,kBAAkB;;IAElB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;;IAET,iBAAiB;;IAEjB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;;IAET,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,SAAS;;IAET,eAAe;IACf,uBAAuB;EACzB","sourcesContent":[".linkEditor {\n    position: absolute;\n    z-index: 10;\n    top: 0;\n    left: 0;\n\n    display: flex;\n\n    width: 100%;\n    max-width: 400px;\n\n    transition: opacity 0.5s;\n\n    opacity: 0;\n    border-radius: 0 0 8px 8px;\n    background-color: #fff;\n    box-shadow: 0 5px 10px rgb(0 0 0 / 30%);\n    will-change: transform;\n  }\n\n  .linkInput {\n    position: relative;\n\n    display: block;\n\n    box-sizing: border-box;\n    width: calc(100% - 75px);\n    margin: 12px;\n    padding: 8px 12px;\n\n    color: rgb(5 5 5);\n    border: 0;\n    border-radius: 15px;\n    outline: 0;\n    background-color: #eee;\n\n    font-family: inherit;\n    font-size: 15px;\n  }\n\n  .linkView {\n    position: relative;\n\n    display: block;\n\n    width: calc(100% - 24px);\n    margin: 8px 12px;\n    padding: 8px 12px;\n\n    color: rgb(5 5 5);\n    border: 0;\n    border-radius: 15px;\n    outline: 0;\n\n    font-family: inherit;\n    font-size: 15px;\n  }\n  \n  \n  .link-editor .button {\n    display: inline-block;\n\n    width: 20px;\n    height: 20px;\n    margin: 0 2px;\n    padding: 6px;\n\n    cursor: pointer;\n\n    border-radius: 8px;\n  }\n  \n  .link-editor .button.hovered {\n    display: inline-block;\n\n    width: 20px;\n    height: 20px;\n\n    background-color: #eee;\n  }\n  \n  .link-editor .button i,\n  .actions i {\n    display: inline-block;\n\n    width: 20px;\n    height: 20px;\n\n    vertical-align: -0.25em;\n\n    background-size: contain;\n  }\n\n  .linkCancel {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n\n    margin-right: 28px;\n\n    cursor: pointer;\n    vertical-align: -0.25em;\n  }\n\n  .linkConfirm {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n\n    margin-right: 2px;\n\n    cursor: pointer;\n    vertical-align: -0.25em;\n  }\n\n  .linkTrash {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n\n    cursor: pointer;\n    vertical-align: -0.25em;\n  }\n\n  .linkEdit {\n    position: absolute;\n    top: 0;\n    right: 30px;\n    bottom: 0;\n\n    cursor: pointer;\n    vertical-align: -0.25em;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkEditor": `styles_linkEditor__iQo0-`,
	"linkInput": `styles_linkInput__cL4Ul`,
	"linkView": `styles_linkView__8Vze8`,
	"link-editor": `styles_link-editor__MBiA2`,
	"button": `styles_button__pt-ye`,
	"hovered": `styles_hovered__HmGK-`,
	"actions": `styles_actions__ywMuf`,
	"linkCancel": `styles_linkCancel__0Jjuh`,
	"linkConfirm": `styles_linkConfirm__j7xi0`,
	"linkTrash": `styles_linkTrash__R-OrF`,
	"linkEdit": `styles_linkEdit__QOrjk`
};
export default ___CSS_LOADER_EXPORT___;
